<template>
  <div class="multi-uint-prop">
    <div class="multi-uint-prop__item" v-for="(fv, fvIndex) in list" :key="fv.prefix + '_' + fvIndex">
      <span class="multi-uint-prop__title">{{ fv.prefix }}:</span>
      <el-input-digit v-model="fv.attrValue" :precision="3"/>
      <template v-if="fv.unit && fv.unit.length">
        <span class="multi-uint-prop__select" v-if="fv.unit.length <= 1">{{ fv.unit[0] }}</span>
        <el-select class="multi-uint-prop__select" v-else v-model="fv.checkedUnit">
          <el-option v-for="item in fv.unit"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </template>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { getCombinationInputs } from '../service';

export default {
  props: {
    propConfig: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemPropValues: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    propConfig: {
      immediate: true,
      handler(propConfig) {
        const defaultValue = {
          attrId: propConfig.id,
          attrValues: [], // ['100', '20', '50']
          expands: [], // ['长', '宽', '高']
          units: [], // ['m', 'mm', 'mm']
        }
        let propValue = this.itemPropValues.find(it => it.attrId == propConfig.id) || defaultValue;
        propValue = cloneDeep(propValue);
        if (!propValue.units) {
          propValue.units = [];
        }
        let list = getCombinationInputs(propConfig.features);
        list.forEach(it => {
          const index = (propValue.expands || []).findIndex(item => item === it.prefix);
          it.attrValue = index == -1 ? '' : (propValue.attrValues[index] ?? '');
          it.checkedUnit = (index == -1 ? '' : propValue.units[index]) || it.unit[0];
        });
        this.list = list;
      },
    },
    list: {
      deep: true,
      handler(val) {
         const itemPropValues = cloneDeep(this.itemPropValues);
        let propValue = itemPropValues.find(it => it.attrId == this.propConfig.id);
        if (!propValue) return;
        Object.assign(propValue, this.combine(val));
        this.$emit('update', itemPropValues);
      }
    },
  },
  methods: {
    // 数据组合
    combine(list) {
      let newData = list.reduce((acc, cur) => {
        acc.attrValues.push(cur.attrValue);
        acc.expands.push(cur.prefix);
        acc.units.push(cur.checkedUnit);
        return acc;
      }, {
        attrValues: [],
        expands: [],
        units: []
      });
      return newData;
    },
  },
};
</script>

<style lang="scss" scoped>
.multi-uint-prop__item {
  display: flex;
  font-size: 12px;
  color: #606266;
  margin-bottom: 5px;
  .multi-uint-prop__title {
    min-width: 20px;
  }
  .multi-uint-prop__select {
    width: 84px;
  }
}
</style>
